import React from "react";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-black text-white text-center px-4">
      <h1 className="text-6xl font-bold text-karangou-orange mb-4">404</h1>
      <p className="text-xl mb-6">Oups... cette page n’existe pas !</p>
      <a href="/" className="text-karangou-orange underline">Retour à l’accueil</a>
    </div>
  );
}
